import store from '@/store'
import { setSessionStorageKey } from '@/scripts/sessionStorage'

export class Service {

  constructor(keycloakInstance, userStore, conf) {
    this.keycloakInstance = keycloakInstance
    this.userStore = userStore
    this.conf = conf
  }

  async login(flag) {
    store.commit(this.userStore.mutationsName.setErrorMsg, '')
    try {
      const auth = await this.keycloakInstance.init({
        onLoad: flag === 'login' ? 'login-required' : 'check-sso',
        checkLoginIframe: false
      })

      if (auth) {
        store.commit(this.userStore.mutationsName.setAccessToken, this.keycloakInstance.token)
        await this.refreshToken()
        await this.fetchUserProfile()

        const roleKey = this.keycloakInstance.clientId ?? ''
        this.extractClientRoles(roleKey)
        store.commit(this.userStore.mutationsName.addGroup, this.keycloakInstance.tokenParsed.edu_group)
      } else {
        if (flag !== 'login') {
          window.location.href = '/start'
        }
        store.commit(this.userStore.mutationsName.setErrorMsg, 'Auth failed. Unknown error occurred')
      }
    } catch (error) {
      console.log('error', error)
      store.commit(this.userStore.mutationsName.setErrorMsg, error)
    }
  }

  logout() {
    this.keycloakInstance.logout()
  }

  async fetchUserProfile() {
    try {
      const data = await this.keycloakInstance.loadUserProfile()
      store.commit(this.userStore.mutationsName.setCurrentUser, data)
    } catch (error) {
      store.commit(this.userStore.mutationsName.setErrorMsg, error)
    }
  }

  extractClientRoles(roleKey) {
    if (this.keycloakInstance.resourceAccess &&
      Object.prototype.hasOwnProperty.call(this.keycloakInstance.resourceAccess, roleKey)) {
      this.keycloakInstance.resourceAccess[roleKey].roles.forEach(group => {
        store.commit(this.userStore.mutationsName.addRole, group)
      })
    } else {
      this.logout()
      setSessionStorageKey('failed-login', true)
    }
  }

  async refreshToken() {
    const refreshed = await this.keycloakInstance.updateToken(5)

    if (refreshed) {
      store.commit(this.userStore.mutationsName.setAccessToken, this.keycloakInstance.token)
    }

    setTimeout(async () => {
      await this.refreshToken()
    }, this.conf.refreshTokenMilliseconds)
  }
}
